import React from 'react';
import { Save, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';

export const SecuritySettingsTab = () => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Shield className="h-5 w-5" />
          Security Settings
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <Label>Require Email Verification</Label>
            <p className="text-xs text-slate-500">Users must verify email before accessing site</p>
          </div>
          <Switch defaultChecked />
        </div>
        <div className="flex items-center justify-between">
          <div>
            <Label>Enable Rate Limiting</Label>
            <p className="text-xs text-slate-500">Prevent abuse by limiting requests</p>
          </div>
          <Switch defaultChecked />
        </div>
        <div className="flex items-center justify-between">
          <div>
            <Label>Allow Community Voting</Label>
            <p className="text-xs text-slate-500">Enable voting on unlisted firms</p>
          </div>
          <Switch defaultChecked />
        </div>
        <Button onClick={() => toast.success('Security settings saved')}>
          <Save className="h-4 w-4 mr-2" />
          Save Changes
        </Button>
      </CardContent>
    </Card>
  );
};